<template>
	<div style="width: 100%">
		<div class="title">
			<div class="header">
				<div class="header_title-container title">
					<h1>{{ $t("schools-users") }}</h1>
				</div>

				<div class="header_actions">
					<div class="header_actions-container">
						<option-button
							:show="true"
							:buttons="buttons"
							@add="add = true"
							@clear="selecteds = []"
							@delete="deleting = true"
							@restore="restore = true"
						/>
					</div>
				</div>
			</div>
		</div>
		<div style="width: 100%; display: flex">
			<el-select
				v-model="organization"
				:placeholder="$t('school')"
				value-key="name.String"
				filterable
				remote
				multiple
				reserve-keyword
				:remote-method="doFetchSchool"
				style="width: 100%"
			>
				<el-option v-for="item in schools" :key="item.id" :value="item" :label="item.name.String" />
			</el-select>
			<el-button
				icon="el-icon-search"
				type="primary"
				@click="e => handleSearch(true)"
				style="width: 75px; margin-left: auto; margin-right: 0"
			/>
		</div>
		<br />
		<div :style="{ height: height + 'px' }" style="overflow-y: auto">
			<div v-loading="loading">
				<md-table v-model="users.array" v-if="users && users.array.length > 0">
					<md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="single">
						<md-table-cell width="25">
							<md-checkbox
								:id="item.id"
								v-model="selecteds"
								:value="item"
								@click="e => e.stopPropagation()"
							/>
						</md-table-cell>
						<md-table-cell :md-label="$t('username')">
							{{ item.username }}
						</md-table-cell>
						<md-table-cell :md-label="$t('organization')">
							{{ item.organization ? item.organization.name.String : "" }}
						</md-table-cell>
						<md-table-cell :md-label="$t('last-login')" width="200">
							{{
								item.lastLogin
									? moment(new Date(item.lastLogin * 1000)).format("DD-MM-YYYY HH:mm")
									: $t("never")
							}}
						</md-table-cell>
						<md-table-cell :md-label="$t('status')">
							<el-tag v-if="item.deleted_at" type="danger">{{
								$t("deleted-at") + ": " + moment(item.deleted_at).format("DD-MM-YYYY")
							}}</el-tag>
							<el-tag v-else-if="item.confirmed" type="success">{{ $t("confirmed") }}</el-tag>
							<el-tag v-else>{{ $t("waiting-for") }}</el-tag>
							<el-tag
								v-if="item.reset_code.String"
								type="warning"
								style="margin: 10px"
								@click="e => copyToClipboard(item.reset_code.String)"
								>{{ $t("ask-reset-password") }}</el-tag
							>
						</md-table-cell>
						<!--<md-table-cell width="25">
							<option-table-button placement="bottom"
								@edit="rowClick(item)"
								:buttons="['']"/>
						</md-table-cell>-->
					</md-table-row>
				</md-table>
				<div v-else>
					<p>{{ $t("empty-result") }}</p>
				</div>
			</div>
			<app-pagination
				:tot="pagination.tot"
				:size="pagination.size"
				:offset="pagination.offset"
				@fetch="doFetch"
			/>
		</div>

		<!-- ADD USER -->
		<div v-if="add">
			<add-user :show="add" @close="add = false" />
		</div>

		<!-- DELETE / RESTORE CONFIRM MODAL -->
		<div v-if="deleting || restore">
			<delete-confirm-modal @close="handleFunc" :title="title" :content="content" />
		</div>
	</div>
</template>
<script>
import { mapGetters, mapActions } from "vuex"
import axios from "axios"
import AppPagination from "@/modules/_common/table/app-pagination.vue"
import OptionTableButton from "@/modules/_common/button/option-table-button.vue"
import OptionButton from "@/modules/_common/button/option-button.vue"
import AddUser from "@/modules/organization/form-component/add-user.vue"
import DeleteConfirmModal from "@/modules/_common/modal/delete-confirm-modal.vue"

export default {
	components: {
		OptionTableButton,
		AppPagination,
		OptionButton,
		AddUser,
		DeleteConfirmModal
	},
	name: "schoolsusers-list",
	data() {
		return {
			loading: false,
			height: window.innerHeight - 270,
			selecteds: [],
			pagination: {
				tot: 0,
				size: 50,
				offset: 0
			},
			add: false,
			deleting: false,
			restore: false,
			schools: [],
			organization: []
		}
	},
	computed: {
		...mapGetters({
			users: "users/users"
		}),
		buttons: function () {
			if (this.selecteds.length > 0) {
				var tmp = ["clear"]
				this.selecteds.forEach(e => {
					if (e.deleted_at) {
						if (tmp.findIndex(x => x === "restore") === -1) {
							tmp.push("restore")
						}
					} else {
						if (tmp.findIndex(x => x === "delete") === -1) {
							tmp.push("delete")
						}
					}
				})
				return tmp
			} else {
				return ["add"]
			}
		},
		title: function () {
			return this.deleting ? this.$t("are-you-sure-to-delete-title") : this.$t("are-you-sure-to-restore-title")
		},
		content: function () {
			return !this.restore
				? this.$t("are-you-sure-to-delete-content")
				: this.$t("are-you-sure-to-restore-content")
		}
	},

	methods: {
		...mapActions({
			getList: "users/getList",
			handleDelete: "users/handleDelete",
			handleRestore: "users/handleRestore"
		}),
		clear: function () {
			this.deleting = undefined
			this.restore = undefined
			this.selecteds = []
		},
		handleList: function (organization_ids) {
			this.loading = true
			var payload = {
				offset: this.pagination.offset,
				size: this.pagination.size
			}
			if (organization_ids && organization_ids.length > 0) payload["organization_ids"] = organization_ids
			this.getList(payload)
		},
		doFetch: function (page, size) {
			if (size && page) {
				this.pagination.size = size
				this.pagination.offset = (page - 1) * this.pagination.size
			}

			this.getList(this.pagination)
		},
		async handleFunc(value) {
			if (!value) {
				this.clear()
				return
			}
			var array = []
			this.selecteds.forEach(item => {
				if (this.deleting && item.deleted_at == undefined) array.push(item)
				else if (this.restore && item.deleted_at != undefined) array.push(item)
			})
			if (array.length > 0) {
				var r = undefined
				if (this.deleting) r = await this.handleDelete(array)
				else if (this.restore) r = await this.handleRestore(array)
				if (r === true) this.$notification("success", this.$t("operation-ok"), "", 4000)
				else this.$notification("error", this.$t("something-goes-wrong"), "", 0)
			}
			this.clear()
		},

		handleSearch: function () {
			var array = this.organization.map(item => item.id)
			this.handleList(array)
		},

		doFetchSchool: function (query) {
			axios
				.post(
					process.env.VUE_APP_API_URL + "/api/organizations/search",
					{ query },
					{
						headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
					}
				)
				.then(res => {
					this.schools = res.data
				})
				.catch(err => {
					console.error(err)
				})
		},

		copyToClipboard: function (string) {
			navigator.clipboard.writeText(process.env.VUE_APP_FRONTEND + "/#/resetpassword/" + string)
			this.$notification("success", this.$t("text-copied"), this.$t("text-copied-string"), 6000)
		}
	},
	watch: {
		users: function () {
			this.loading = false
			this.pagination.tot = this.users.count
		}
	},

	created() {
		this.handleList()
	}
}
</script>
